import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {catchError, map, tap, switchMap, withLatestFrom} from 'rxjs/operators';
import { MenuApiService } from '../menu-api.service';
import { FeatureScopeStoreService } from '../../store/feature-scope/feature-scope-store.service';
import {ConsumersActions} from '@emm/menu/store/consumer/consumers.actions';
import {NotificationService} from '@emm/shared/services/notification.service';

@Injectable({
    providedIn: 'root'
})
export class ConsumerEffects {

    featureScope;

    reload$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumersActions.reloadConsumers),
            switchMap(() => of(ConsumersActions.loadAll()))
        )
    );

    loadAll$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumersActions.loadAll),
            withLatestFrom(this.featureScopeStoreService.queries.selected$),
            switchMap(([_, featureScope]) => {
                return this.api.getAllConsumers().pipe(
                    map((consumers) => ConsumersActions.loadAllSuccess({ consumers })),
                    catchError(({ error }) => of(ConsumersActions.loadAllFailure({ error })))
                );
                }
            )
        )
    );

    deleteConsumer$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumersActions.delete),
            switchMap(({ tag }) =>
                this.api.deleteConsumer(tag).pipe(
                    map(() => ConsumersActions.deleteSuccess()),
                    catchError(({ error }) => of(ConsumersActions.deleteFailure({ error })))
                )
            )
        )
    );

    deleteConsumerSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ConsumersActions.deleteSuccess),
            tap((_) => this.notificationService.success('Deleted successfully')),
            switchMap(() => of(ConsumersActions.loadAll()))
        )
    );

    constructor(
        private actions$: Actions,
        private api: MenuApiService,
        private notificationService: NotificationService,
        private featureScopeStoreService: FeatureScopeStoreService,
    ) {}

}
